import { COLOR_MODE_KEY } from "~/composables/useColorMode";

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    try {
      if (localStorage.getItem(COLOR_MODE_KEY) === "dark") {
        document.documentElement.classList.add("dark");
      }
    } catch {}
  }
});
